/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_size_guide = /** @type {(inputs: {}) => string} */ () => {
	return `Průvodce velikostí`
};

const da_size_guide = /** @type {(inputs: {}) => string} */ () => {
	return `Størrelsesguide`
};

const de_size_guide = /** @type {(inputs: {}) => string} */ () => {
	return `Größentabelle`
};

const en_size_guide = /** @type {(inputs: {}) => string} */ () => {
	return `Size guide`
};

const es_size_guide = /** @type {(inputs: {}) => string} */ () => {
	return `Guía de tallas`
};

const fr_size_guide = /** @type {(inputs: {}) => string} */ () => {
	return `Guide des tailles`
};

const hu_size_guide = /** @type {(inputs: {}) => string} */ () => {
	return `Mérettáblázat`
};

const it_size_guide = /** @type {(inputs: {}) => string} */ () => {
	return `Guida alle taglie`
};

const nl_size_guide = /** @type {(inputs: {}) => string} */ () => {
	return `Maattabel`
};

const pl_size_guide = /** @type {(inputs: {}) => string} */ () => {
	return `Przewodnik po rozmiarach`
};

const pt_size_guide = /** @type {(inputs: {}) => string} */ () => {
	return `Guia de tamanhos`
};

const sv_size_guide = /** @type {(inputs: {}) => string} */ () => {
	return `Storleksguide`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const size_guide = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.size_guide(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("size_guide", locale)
	if (locale === "cs") return cs_size_guide(inputs)
	if (locale === "da") return da_size_guide(inputs)
	if (locale === "de") return de_size_guide(inputs)
	if (locale === "en") return en_size_guide(inputs)
	if (locale === "es") return es_size_guide(inputs)
	if (locale === "fr") return fr_size_guide(inputs)
	if (locale === "hu") return hu_size_guide(inputs)
	if (locale === "it") return it_size_guide(inputs)
	if (locale === "nl") return nl_size_guide(inputs)
	if (locale === "pl") return pl_size_guide(inputs)
	if (locale === "pt") return pt_size_guide(inputs)
	return sv_size_guide(inputs)
};